import {ObjectProperties} from './communicationProperties';
import {QueryableProperty} from '../queryableProperty';

export class CategoryProperties extends ObjectProperties {
    constructor() {
        super();
        this.properties = [
            // new QueryableProperty('wildcard', 'Wildcard', 'wildcard'),
            new QueryableProperty('name', 'Name', 'string', false),
            new QueryableProperty('shortDescription', 'Description', 'string', false),
        ];
        this.sortingPropertyName = 'creationDate';
        this.sortingDescending = true;
    }
}
